module.exports = __webpack_public_path__ + "static/media/Banner-Habeas2025.74ef2b61.png";